import React from 'react';
import { motion } from 'framer-motion';

export default function Mission() {
  return (
    <section id="mission" className="py-24 px-6 md:px-8" style={{ backgroundColor: 'var(--bg)' }}>
      <div className="container-premium flex flex-col items-center text-center">
        <div className="eyebrow mb-4">Our Mission</div>
        <h2 className="t-h1 font-display mb-8" style={{ color: 'var(--text-primary)' }}>Talent, Not Titles</h2>
        <motion.blockquote
          className="t-h2 font-normal italic mb-10 max-w-3xl"
          style={{ color: 'var(--text-secondary)' }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
        >
          "We believe in the power of curiosity, creativity, and thinkers from every background.
          No degree required — just a mind for the future."
        </motion.blockquote>
        <div className="flex flex-wrap gap-4 justify-center">
          {['No Degree Needed', 'Part-Timers Welcome', 'Curiosity + Creativity'].map((text, i) => (
            <motion.span
              key={text}
              className="chip"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.1 + i * 0.1 }}
            >
              {text}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
